import { Box } from "@mui/material";
import React from "react";

// eslint-disable-next-line import/prefer-default-export
export function GeneralAttendanceSettings(): React.ReactNode {
  return <Box sx={{ p: 2 }}>.</Box>;
}
